// test1527
(1527 && 0);
